export const getQueryKey = (uuid: string) => [
  'biddable-listing',
  'listingUuid',
  uuid,
];
